module.exports = __webpack_public_path__ + "img/popover.57d9d6bf.svg";